// ** React Imports
import { useState } from 'react'

// ** Third Party Imports
import * as RadixAlertDialog from '@radix-ui/react-alert-dialog'

// ** Component Imports
import { Button } from '../../index'

// ** Styled Components
import {
	StyledContent,
	StyledActions,
	StyledDescription,
	StyledOverlay,
	StyledTitle
} from './styles'

interface IProps {
	open?: boolean
	openChange?: (open: boolean) => void
	title?: string
	Trigger?: JSX.Element
	cancelText?: string
	confirmText?: string
	description?: string
	confirmAction?: () => void
	confirmColor?: 'primary' | 'secondary' | 'success' | 'error' | 'warning'
}

export const AlertDialog = ({
	open,
	openChange,
	title,
	Trigger,
	cancelText,
	confirmText,
	description,
	confirmAction,
	confirmColor
}: IProps) => {
	// ** State
	const [openDialog, setOpenDialog] = useState<boolean>(false)

	return (
		<RadixAlertDialog.Root
			open={open ?? openDialog}
			onOpenChange={openChange ?? setOpenDialog}
		>
			<RadixAlertDialog.Trigger asChild>{Trigger}</RadixAlertDialog.Trigger>
			<RadixAlertDialog.Portal>
				<StyledOverlay />
				<StyledContent>
					<StyledTitle>{title ?? 'Title'}</StyledTitle>
					<StyledDescription>
						{description ?? 'Placeholder text.'}
					</StyledDescription>
					<StyledActions>
						<RadixAlertDialog.Cancel asChild>
							<Button
								fullWidth
								variant='secondary'
								label={cancelText ?? 'Cancel'}
							/>
						</RadixAlertDialog.Cancel>
						<RadixAlertDialog.Action asChild>
							<Button
								fullWidth
								variant='primary'
								color={confirmColor}
								label={confirmText ?? 'Confirm'}
								onClick={confirmAction}
							/>
						</RadixAlertDialog.Action>
					</StyledActions>
				</StyledContent>
			</RadixAlertDialog.Portal>
		</RadixAlertDialog.Root>
	)
}
